import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import useCustomerReducer from '@themes/account/useCustomerReducer';
import { styled } from '@mui/material/styles';
export const AccountSellerWrapper = styled((props) => _jsx(Paper, Object.assign({}, props, { elevation: 0 })))(({ theme }) => ({
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    width: '300px',
}));
export const LinkStyled = styled(Link)(({ theme }) => ({
    color: '#000000',
    textDecorationColor: '#000000',
    '&:hover': {
        textDecorationColor: '#000000',
    },
}));
export const SubTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette.grey[700],
    marginBottom: theme.spacing(2),
}));
export const SellerImage = styled((props) => (_jsx("div", { className: 'image-cover cover-loaded aspect-ratio--1-1', style: {
        backgroundImage: `url(${props.src})`,
    } })))(({ theme }) => ({
    width: '100%',
    marginBottom: theme.spacing(2),
}));
export const SellerName = styled(Typography)(({ theme }) => ({
    fontWeight: 600,
    marginTop: theme.spacing(1),
}));
const AccountSellerCard = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const [{ customer }] = useCustomerReducer();
    const seller = useMemo(() => (customer === null || customer === void 0 ? void 0 : customer.accountManager) || (customer === null || customer === void 0 ? void 0 : customer.seller), [customer]);
    const location = (_c = (_b = (_a = customer === null || customer === void 0 ? void 0 : customer.metaobjects) === null || _a === void 0 ? void 0 : _a.seller) === null || _b === void 0 ? void 0 : _b.fields.find((field) => field.key === 'location')) === null || _c === void 0 ? void 0 : _c.value;
    const imageUrl = (_h = (_g = (_f = (_e = (_d = customer === null || customer === void 0 ? void 0 : customer.metaobjects) === null || _d === void 0 ? void 0 : _d.seller) === null || _e === void 0 ? void 0 : _e.fields.find((field) => field.key === 'image')) === null || _f === void 0 ? void 0 : _f.reference) === null || _g === void 0 ? void 0 : _g.image) === null || _h === void 0 ? void 0 : _h.url;
    return seller ? (_jsxs(AccountSellerWrapper, { children: [imageUrl && _jsx(SellerImage, { src: imageUrl }), _jsxs(SellerName, { children: [seller.firstName, " ", seller.lastName] }), location && _jsx(SubTypography, { children: location }), _jsx(LinkStyled, Object.assign({ href: `tel:${seller.cellPhoneNumber || seller.phoneNumber}` }, { children: seller.cellPhoneNumber || seller.phoneNumber })), _jsx(LinkStyled, Object.assign({ href: `mailto:${seller.emailAddress}` }, { children: seller.emailAddress }))] })) : (_jsx(_Fragment, {}));
};
export default AccountSellerCard;
